/*
 * 来店予約ボタンを押したときに、Googleカレンダーの予約ページをポップアップで開く（snippets/entid-reservation-modal.liquid）。
 * 来店予約ボタン（TOPのショールーム欄、商品詳細、スマホメニュー、ACCESSの予約欄）は、リンク先が予約ページのURLになっている（snippets/entid-reservation-url.liquid）。
 * そのURLへのリンクが押されたら移動を止めてポップアップを開く。このスクリプトが動かないときは、リンクのとおり予約ページへ移動する。
 */
(() => {
  const modal = document.getElementById('EntidReservationModal');
  if (!modal || typeof modal.show !== 'function') return;

  const target = new URL(modal.dataset.url, window.location.href).href;
  const frame = modal.querySelector('.entid-reservation-modal__frame');

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.href !== target) return;
    event.preventDefault();

    // スマホのメニューから押したときは、メニューを閉じてから開く
    const drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
    }

    if (frame && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src);
    modal.show(link);
  });
})();
